import React from "react";
import { connect } from "react-redux";
import { Button, ValidationGroup } from "devextreme-react";
import validaciones from "../../../../../../../helpers/validaciones";
import { lastStep, nextStep, setDataNewComplain, setCodigoAreaAll, goGetDenuncianteData } from "../../actions";
import TextField from "../../../../../../Shared/fields/TextField";
import SelectField from "../../../../../../Shared/fields/SelectField";
import { getCodigoAreaAll } from "../../../../../../../helpers/direccionesNuevaDenunciaFormat";

class Denunciante extends React.PureComponent {
  constructor(props) {
    super(props);

    // this.topRef = React.createRef();
    if (!props.jsonData.formDenunciante.FirstName) {
      props.dispatch(goGetDenuncianteData(props.userData.RUT))
    }
  }

  componentDidMount = () => {
    if (this.props.listaCodigoArea && this.props.listaCodigoArea.length === 0) {
      this.props.dispatch(setCodigoAreaAll(getCodigoAreaAll(this.props.listaDirecciones)));
    }
  }

  handleNext = (params) => {
    const result = params.validationGroup.validate();
    if (result.isValid) {
      // this.topRef.current.scrollIntoView();
      this.props.dispatch(nextStep());
      // this.props.onSave(false);
    }
  }

  handleBack = () => {
    // this.topRef.current.scrollIntoView();
    this.props.dispatch(lastStep());
  }

  handleChange = (e) => {
    const jsonData = { ...this.props.jsonData };

    switch (e.element.id) {
      case "FirstName": {
        jsonData.formDenunciante.FirstName = e.value;
        break;
      }
      case "ApellidoPaterno": {
        jsonData.formDenunciante.LastName = e.value;
        break;
      }
      case "ApellidoMaterno": {
        jsonData.formDenunciante.MothersName = e.value;
        break;
      }
      case "Rut": {
        jsonData.formDenunciante.Rut = e.value;
        break;
      }
      case "telefono": {
        jsonData.formDenunciante.Phone = e.value;
        break;
      }
      case "codigo": {
        jsonData.formDenunciante.Code = e.value;
        break;
      }
      default:
        break;
    }

    this.props.dispatch(setDataNewComplain(jsonData));
  }

  render() {
    const form = this.props.jsonData.formDenunciante;

    return (
      <ValidationGroup className="row">
        <div className="col-12 newDenuncia-title"> {/* ref={this.topRef}> */}
          <h2>Denunciante</h2>
          <p>Completa los datos para pasar a la siguiente sección</p>
        </div>
        <div className="col-12">
          <h4 className="newDenuncia-subtitle">Datos del denunciante</h4>
        </div>
        <div className="col-12">
          <TextField
            label="Nombres"
            maxLength={80}
            id="Nombres"
            disabled={form.cantEditFirstName}
            onChange={this.handleChange}
            value={form.FirstName}
          />
          <TextField
            label="Apellido paterno"
            id="ApellidoPaterno"
            maxLength={30}
            disabled={form.cantEditLastName}
            onChange={this.handleChange}
            value={form.LastName}
          />
          <TextField
            label="Apellido materno"
            id="ApellidoMaterno"
            required
            maxLength={30}
            disabled={form.cantEditMothersName}
            onChange={this.handleChange}
            value={form.MothersName}
          />
          <TextField
            label="Rut"
            disabled={this.props.userData.RUT != null}
            id="Rut"
            onChange={this.handleChange}
            value={validaciones.formatRut(form.Rut, { showDots: true, showHyphen: true })}
          />

          <div className="row zero-vertical">
            <div className="col-1" style={{ color: "#787878", marginTop: 54 }}> +56 </div>
            <div className="col-4 zero-right">
              <SelectField
                label="Código de área"
                id="codigo"
                required
                value={form.Code}
                acceptCustomValue
                onValueChanged={this.handleChange}
                items={this.props.listaCodigoArea}
              />
            </div>
            <div className="col-7">
              <TextField
                label="Teléfono"
                required
                maxLength={8}
                id="telefono"
                mask={form.Code && form.Code.indexOf("+") !== -1 ? "0000 0000" : null}
                value={form.Phone}
                onValueChanged={this.handleChange}
              />

            </div>
          </div>

          <Button text="Volver" className="newDenuncia-back-button" onClick={this.handleBack} />
          <Button
            text="Siguiente"
            type="success"
            className="newDenuncia-next-button"
            onClick={this.handleNext}
            useSubmitBehavior
          />

        </div>
      </ValidationGroup>
    );
  }
}
const mapStateToProps = (state) => ({
  userData: state.global.userData,
  jsonData: state.denuncias.jsonData,
  listaCodigoArea: state.denuncias.listaCodigoAreaAll,
  listaDirecciones: state.global.listaDirecciones,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});

export default connect(mapStateToProps, mapDispatchToProps)(Denunciante);
